import '../../styles/settings.css'
import { STATE, USERSTATES } from '../../classes/Enum';
import ImageComponent from '../Image';
import { useEffect, useState } from 'react';
import { login, register, updateAddress } from "../../api/auth";
import { getUserDetails } from '../../api/auth';
import OrderHistoryComponent from './Orders';
import ProfileComponent from './Profile';

const UserModule = ({user, items, userState, setUserState}) => {

    useEffect(() => {
        if (user && userState === USERSTATES.SIGN) {
            setUserState(USERSTATES.SETTINGS);
        }
    })

    return <div>
        {(userState === USERSTATES.SIGN) ? <SignInOrUpComponent setUserState={setUserState}/> : null}
        {userState === USERSTATES.LOGIN && <LoginComponent setUserState={setUserState}/>}
        {userState === USERSTATES.REGISTER && <RegisterComponent setUserState={setUserState}/>}
        {(userState === USERSTATES.PROFILE && user) && <ProfileComponent user={user}/>}
        {(userState === USERSTATES.SETTINGS && user) && <AccountSettingsComponent setUserState={setUserState}/>}
        {(userState === USERSTATES.ORDERS && user) && <OrderHistoryComponent user={user} items={items}/>}
    </div>
}

const AccountSettingsComponent = ({setUserState}) => {

    function handleLogOut() {
        localStorage.clear();
        window.location.reload();
    }

    return <div id="menu-wrapper">
        <div id="menu-container">
        <button className='menu-button' onClick={() => setUserState(USERSTATES.PROFILE)}>
            <ImageComponent imageSrc={'assets/imgs/profile3.png' }/>
            Profile</button>
        <button className='menu-button'>
            <ImageComponent imageSrc={'assets/imgs/Green Pencil.png' }/>
            Coupons (Coming soon!)</button>
        <button className='menu-button' onClick={() => setUserState(USERSTATES.ORDERS)}>
            <ImageComponent imageSrc={'assets/imgs/psyduck.png' }/>
            Orders</button>
        <button className='menu-button' onClick={handleLogOut}>
            <ImageComponent imageSrc={'assets/imgs/logout.png' }/>
            Log Out
            </button>
        </div>
    </div>
}

const SignInOrUpComponent = ({setUserState}) => {

    return <div id="menu-wrapper">
        <div id="menu-container">
            <button className='menu-button' onClick={() => setUserState(USERSTATES.REGISTER)}>
                <ImageComponent imageSrc={'assets/imgs/SIGN UP.png' }/>
                Register
            </button>
            <button className='menu-button' onClick={() => setUserState(USERSTATES.LOGIN)}>
                <ImageComponent imageSrc={'assets/imgs/SIGN IN.png' }/>
                Log in
            </button>
        </div>
    </div>
}

const RegisterComponent = ({setUserState}) => {
    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [birthday, setBirthday] = useState("");
    const [tikTokName, setTikTokName] = useState("");
    const [errorMessage, setErrorMessage] = useState(null);
    const [password, setPassword] = useState(null);

    const handleRegister = async () => {
        try {
            const response = await register(email, password, firstName, lastName, birthday, tikTokName);
            if (response === 201) {
                // Assuming the login function returns a success property
                setUserState(USERSTATES.LOGIN);
            } else {
                setErrorMessage(response.message || "Login failed. Please try again.");
            }
        } catch (error) {
            setErrorMessage("An error occurred. Please check your credentials and try again.");
        }
    };

    return <div id="login-container">
        <h1>REGISTER</h1>
        <div>
            <form onSubmit={(e) => e.preventDefault()}>
                <div id="login">
                    <label className='label'>
                    First Name
                    <input
                        className="input-box"
                        type="text"
                        name="firstName"
                        placeholder="e.g. Ash"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                    />
                    </label>
                    <label className='label'>
                        Last Name
                        <input
                            className="input-box"
                            type="text"
                            name="lastName"
                            placeholder="e.g. Ketchum"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            required
                        />
                    </label>
                    <label className='label'>
                        Email
                        <input
                            className="input-box"
                            type="text"
                            name="username"
                            placeholder="e.g. funnyguy@gmail.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </label>
                    <label className='label'>
                        D.O.B
                        <input
                        className="input-box"
                        type="date"
                        name="Date of Birth"
                        placeholder="DOB"
                        value={birthday}
                        onChange={(e) => setBirthday(e.target.value)}
                        required
                    />
                    </label>
                    <label className='label'>
                        Password
                        <input
                        className="input-box"
                        type="password"
                        name="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        />
                    </label>
                    <label className='label'>
                        TikTok Username
                        <input
                        className="input-box"
                        type="text"
                        name="TikTok Username"
                        placeholder="e.g. avgpokecollector"
                        value={tikTokName}
                        onChange={(e) => setTikTokName(e.target.value)}
                        required
                        />
                    </label>
                </div>
            </form>
            {errorMessage && <p className="error-message">{errorMessage}</p>}
        </div>
        <button className="button" onClick={handleRegister}>
                Register!
            </button>
    </div>
}

const LoginComponent = ({ setUserState }) => {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState(null);

    const handleLogin = async () => {
        try {
            const response = await login(email, password);
            if (response === 200) {
                // Assuming the login function returns a success property
                window.location.reload();
            } else {
                setErrorMessage(response.message || "Login failed. Please try again.");
            }
        } catch (error) {
            setErrorMessage("An error occurred. Please check your credentials and try again.");
        }
    };

    return (
        <div id="login-container">
            <h1>LOG IN</h1>
            <div>
                <form onSubmit={(e) => e.preventDefault()}>
                    <div id="login">
                        <input
                            className="input-box"
                            type="text"
                            name="username"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <input
                            className="input-box"
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                </form>
                {errorMessage && <p className="error-message">{errorMessage}</p>}
                <button className="button" onClick={handleLogin}>
                    Login!
                </button>
            </div>
        </div>
    );
};

export default UserModule
